<template>
  <div class="cell-wrapper" 
       :class="{'clickable': clickable}"
  >
    <slot></slot>
  </div>
</template>

<script>
export default {
  name: 'ChecklistTableTaskCellWrapper',
  props: {
    clickable: {
      type: Boolean,
      required: true,
    },
  },
}
</script>

<style scoped>
.cell-wrapper {
  border: 1px solid transparent;
  border-radius: 8px;
  height: 100%;
  padding: 8px 12px;
  transition: border-color 0.2s ease-in-out;

  &.clickable:hover {
    border-color: rgb(var(--v-theme-border-primary));
  }
}
</style>
